import { useState } from "react";
import TextInput from "../Inputs/TextInput";
import { Sidebar } from "primereact/sidebar";

import commonStyle from "../../content/CommonStyles.module.css";
import { Button } from "primereact/button";

const NewValueCreationSidebar = ({visible, onHide, onSelect}) => {

    const [value, setValue] = useState(null);

    const onAddingValue = () => {
        if (value) {
            onSelect(value);
            setValue(null);
        }
    }

    return (
        <Sidebar visible={visible} position="right" onHide={onHide} className={`${commonStyle.sidebarmoved} ${commonStyle.shortSideBar}`} header={<h3>Меню додавання значення</h3>}>
            <TextInput value={value} label={"Значення"} setFunction={(val) => setValue(val)} customStyle="w-full" mandatory />
            <div>
                <Button label="Додати" severity="success" type="button" onClick={onAddingValue} className={`${commonStyle.sideBarButton} ${commonStyle.addButton}`} autoFocus />
            </div>
        </Sidebar>
    );
}

export default NewValueCreationSidebar;